/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';

import {
  Crop,
  LegalNitrogenWorkingCoefficient,
  CropVarietySpecificNorm,
  CropVarietySpecificNormFilter,
  PaginationState,
  SoilType,
  TotalNitrogenLegalNorm,
  TotalNitrogenLegalNormFilter,
  LegalNitrogenWorkingCoefficientsFilter,
  CropVariety,
  PhosphateLegalNorm,
  PhosphateLegalNormFilter,
  CropAid,
  SalesOrderPeriod,
  PhosphateLegalWorkingCoefficient,
} from '../shared/models';

export enum AppActionTypes {
  ContextChanged = '[App] Context changed',
  LoadCropsRequest = '[Crop] Load Crops request',
  LoadCropsSuccess = '[Crop] Load Crops success',
  LoadCropVarietiesByCropIdRequest = '[CropVariety] Load CropVarieties by CropId request',
  LoadCropVarietiesByCropIdSuccess = '[CropVariety] Load CropVarieties by CropId success',
  ClearCropVarieties = '[CropVariety] Clear CropVarieties',
  LoadSoilTypesRequest = '[SoilType] Load SoilTypes request',
  LoadSoilTypesSuccess = '[SoilType] Load SoilTypes success',
  LoadSalesOrderPeriodsRequest = '[Sales order periods] Load SalesOrderPeriods request',
  LoadSalesOrderPeriodsSuccess = '[Sales order periods] Load SalesOrderPeriods success',
  LoadCropAidsRequest = '[CropAids] Load CropAids request',
  LoadCropAidsSuccess = '[CropAids] Load CropAids success',
  DownloadAdviceReport = '[Reports] Download advice report',
  DownloadAdviceReportSuccess = '[Reports] Download advice report success',
  DownloadManureSpaceReport = '[Reports] Download manure space report',
  DownloadManureSpaceReportSuccess = '[Reports] Download manure space report success',
  LoadTotalNitrogenLegalNormsRequest = '[TotalNitrogenLegalNorm] Load TotalNitrogenLegalNorms request',
  LoadTotalNitrogenLegalNormsSuccess = '[TotalNitrogenLegalNorm] Load TotalNitrogenLegalNorms success',
  UpsertTotalNitrogenLegalNormRequest = '[TotalNitrogenLegalNorm] Upsert TotalNitrogenLegalNorm request',
  UpsertTotalNitrogenLegalNormSuccess = '[TotalNitrogenLegalNorm] Upsert TotalNitrogenLegalNorm success',
  DeleteTotalNitrogenLegalNormRequest = '[TotalNitrogenLegalNorm] Delete TotalNitrogenLegalNorm request',
  DeleteTotalNitrogenLegalNormSuccess = '[TotalNitrogenLegalNorm] Delete TotalNitrogenLegalNorm success',
  UpdateTotalNitrogenLegalNormFilter = '[TotalNitrogenLegalNorm] Update TotalNitrogenLegalNorm filter',
  ClearTotalNitrogenLegalNormFilter = '[TotalNitrogenLegalNorm] Clear TotalNitrogenLegalNorm filter',
  OpenTotalNitrogenLegalNormImportForm = '[TotalNitrogenLegalNorm] Open TotalNitrogenLegalNorm import form',
  AddTotalNitrogenLegalNorm = '[TotalNitrogenLegalNorm] Add TotalNitrogenLegalNorm',
  EditTotalNitrogenLegalNorm = '[TotalNitrogenLegalNorm] Edit TotalNitrogenLegalNorm',
  DeleteTotalNitrogenLegalNorm = '[TotalNitrogenLegalNorm] Delete TotalNitrogenLegalNorm',
  LoadLegalNitrogenWorkingCoefficientsRequest = '[LegalNitrogenWorkingCoefficients] Load legalNitrogenWorkingCoefficients request',
  LoadLegalNitrogenWorkingCoefficientsSuccess = '[LegalNitrogenWorkingCoefficients] Load legalNitrogenWorkingCoefficients success',
  UpsertLegalNitrogenWorkingCoefficientRequest = '[LegalNitrogenWorkingCoefficients] Upsert legalNitrogenWorkingCoefficients request',
  UpsertLegalNitrogenWorkingCoefficientSuccess = '[LegalNitrogenWorkingCoefficients] Upsert legalNitrogenWorkingCoefficients success',
  DeleteLegalNitrogenWorkingCoefficientRequest = '[LegalNitrogenWorkingCoefficients] Delete legalNitrogenWorkingCoefficients request',
  DeleteLegalNitrogenWorkingCoefficientSuccess = '[LegalNitrogenWorkingCoefficients] Delete legalNitrogenWorkingCoefficients success',
  UpdateLegalNitrogenWorkingCoefficientsFilter = '[LegalNitrogenWorkingCoefficients] Update legalNitrogenWorkingCoefficients filter',
  ClearLegalNitrogenWorkingCoefficientsFilter = '[LegalNitrogenWorkingCoefficients] Clear legalNitrogenWorkingCoefficients filter',
  AddLegalNitrogenWorkingCoefficient = '[LegalNitrogenWorkingCoefficients] Add legalNitrogenWorkingCoefficients',
  EditLegalNitrogenWorkingCoefficient = '[LegalNitrogenWorkingCoefficients] Edit legalNitrogenWorkingCoefficients',
  DeleteLegalNitrogenWorkingCoefficient = '[LegalNitrogenWorkingCoefficients] Delete legalNitrogenWorkingCoefficients',
  OpenLegalNitrogenWorkingCoefficientImportForm = '[LegalNitrogenWorkingCoefficients] Open LegalNitrogenWorkingCoefficient import form',
  LoadCropVarietySpecificNormsRequest = '[CropVarietySpecificNorm] Load CropVarietySpecificNorms request',
  LoadCropVarietySpecificNormsSuccess = '[CropVarietySpecificNorm] Load CropVarietySpecificNorms success',
  UpsertCropVarietySpecificNormRequest = '[CropVarietySpecificNorm] Upsert CropVarietySpecificNorm request',
  UpsertCropVarietySpecificNormSuccess = '[CropVarietySpecificNorm] Upsert CropVarietySpecificNorm success',
  DeleteCropVarietySpecificNormRequest = '[CropVarietySpecificNorm] Delete CropVarietySpecificNorm request',
  DeleteCropVarietySpecificNormSuccess = '[CropVarietySpecificNorm] Delete CropVarietySpecificNorm success',
  GetCropVarietySpecificNormFilter = '[CropVarietySpecificNorm] Get CropVarietySpecificNorm filter',
  UpdateCropVarietySpecificNormFilter = '[CropVarietySpecificNorm] Update CropVarietySpecificNorm filter',
  ClearCropVarietySpecificNormFilter = '[CropVarietySpecificNorm] Clear CropVarietySpecificNorm filter',
  AddCropVarietySpecificNorm = '[CropVarietySpecificNorm] Add CropVarietySpecificNorm',
  EditCropVarietySpecificNorm = '[CropVarietySpecificNorm] Edit CropVarietySpecificNorm',
  DeleteCropVarietySpecificNorm = '[CropVarietySpecificNorm] Delete CropVarietySpecificNorm',
  OpenCropVarietySpecificNormsImportForm = '[CropVarietySpecificNorm] Open CropVarietySpecificNorms import form',
  LoadPhosphateLegalNormsRequest = '[PhosphateLegalNorm] Load PhosphateLegalNorms request',
  LoadPhosphateLegalNormsSuccess = '[PhosphateLegalNorm] Load PhosphateLegalNorms success',
  UpsertPhosphateLegalNormRequest = '[PhosphateLegalNorm] Upsert PhosphateLegalNorm request',
  UpsertPhosphateLegalNormSuccess = '[PhosphateLegalNorm] Upsert PhosphateLegalNorm success',
  DeletePhosphateLegalNormRequest = '[PhosphateLegalNorm] Delete PhosphateLegalNorm request',
  DeletePhosphateLegalNormSuccess = '[PhosphateLegalNorm] Delete PhosphateLegalNorm success',
  UpdatePhosphateLegalNormFilter = '[PhosphateLegalNorm] Update PhosphateLegalNorm filter',
  ClearPhosphateLegalNormFilter = '[PhosphateLegalNorm] Clear PhosphateLegalNorm filter',
  AddPhosphateLegalNorm = '[PhosphateLegalNorm] Add PhosphateLegalNorm',
  EditPhosphateLegalNorm = '[PhosphateLegalNorm] Edit PhosphateLegalNorm',
  DeletePhosphateLegalNorm = '[PhosphateLegalNorm] Delete PhosphateLegalNorm',
  OpenPhosphateLegalNormImportForm = '[PhosphateLegalNorm] Open PhosphateLegalNorm import form',
  AddPhosphateLegalWorkingCoefficient = '[PhosphateLegalWorkingCoefficients] Add phosphateLegalWorkingCoefficients',
  EditPhosphateLegalWorkingCoefficient = '[PhosphateLegalWorkingCoefficients] Edit phosphateLegalWorkingCoefficients',
  DeletePhosphateLegalWorkingCoefficient = '[PhosphateLegalWorkingCoefficients] Delete phosphateLegalWorkingCoefficients',
  LoadPhosphateLegalWorkingCoefficientsRequest = '[PhosphateLegalWorkingCoefficients] Load phosphateLegalWorkingCoefficients request',
  LoadPhosphateLegalWorkingCoefficientsSuccess = '[PhosphateLegalWorkingCoefficients] Load phosphateLegalWorkingCoefficients success',
  UpsertPhosphateLegalWorkingCoefficientRequest = '[PhosphateLegalWorkingCoefficients] Upsert phosphateLegalWorkingCoefficients request',
  UpsertPhosphateLegalWorkingCoefficientSuccess = '[PhosphateLegalWorkingCoefficients] Upsert phosphateLegalWorkingCoefficients success',
  DeletePhosphateLegalWorkingCoefficientRequest = '[PhosphateLegalWorkingCoefficients] Delete phosphateLegalWorkingCoefficients request',
  DeletePhosphateLegalWorkingCoefficientSuccess = '[PhosphateLegalWorkingCoefficients] Delete phosphateLegalWorkingCoefficients success',
  UpdatePhosphateLegalWorkingCoefficientsFilter = '[PhosphateLegalWorkingCoefficients] Update phosphateLegalWorkingCoefficients filter',
  ClearPhosphateLegalWorkingCoefficientsFilter = '[PhosphateLegalWorkingCoefficients] Clear phosphateLegalWorkingCoefficients filter',
}

export class ContextChanged implements Action {
  readonly type = AppActionTypes.ContextChanged;
}

export class LoadCropsRequest implements Action {
  readonly type = AppActionTypes.LoadCropsRequest;
}

export class LoadCropsSuccess implements Action {
  readonly type = AppActionTypes.LoadCropsSuccess;

  constructor(public readonly crops: Crop[]) {}
}

export class LoadCropVarietiesByCropIdRequest implements Action {
  readonly type = AppActionTypes.LoadCropVarietiesByCropIdRequest;

  constructor(public readonly cropId: number) {}
}

export class LoadCropVarietiesByCropIdSuccess implements Action {
  readonly type = AppActionTypes.LoadCropVarietiesByCropIdSuccess;

  constructor(
    public readonly cropId: number,
    public readonly cropVarieties: CropVariety[],
  ) {}
}

export class ClearCropVarieties implements Action {
  readonly type = AppActionTypes.ClearCropVarieties;
}

export class LoadSoilTypesRequest implements Action {
  readonly type = AppActionTypes.LoadSoilTypesRequest;
}

export class LoadSoilTypesSuccess implements Action {
  readonly type = AppActionTypes.LoadSoilTypesSuccess;

  constructor(public readonly soilTypes: SoilType[]) {}
}

export class LoadSalesOrderPeriodsRequest implements Action {
  readonly type = AppActionTypes.LoadSalesOrderPeriodsRequest;

  constructor(public readonly year: number) {}
}

export class LoadSalesOrderPeriodsSuccess implements Action {
  readonly type = AppActionTypes.LoadSalesOrderPeriodsSuccess;

  constructor(public readonly salesOrderPeriods: SalesOrderPeriod[]) {}
}

export class LoadCropAidsRequest implements Action {
  readonly type = AppActionTypes.LoadCropAidsRequest;
}

export class LoadCropAidsSuccess implements Action {
  readonly type = AppActionTypes.LoadCropAidsSuccess;

  constructor(public readonly cropAids: CropAid[]) {}
}

export class DownloadAdviceReport implements Action {
  readonly type = AppActionTypes.DownloadAdviceReport;

  constructor(public readonly year: number) {}
}

export class DownloadAdviceReportSuccess implements Action {
  readonly type = AppActionTypes.DownloadAdviceReportSuccess;
}

export class DownloadManureSpaceReport implements Action {
  readonly type = AppActionTypes.DownloadManureSpaceReport;

  constructor(public readonly year: number) {}
}

export class DownloadManureSpaceReportSuccess implements Action {
  readonly type = AppActionTypes.DownloadManureSpaceReportSuccess;
}

export class OpenTotalNitrogenLegalNormImportForm implements Action {
  readonly type = AppActionTypes.OpenTotalNitrogenLegalNormImportForm;
}

export class OpenLegalNitrogenWorkingCoefficientImportForm implements Action {
  readonly type = AppActionTypes.OpenLegalNitrogenWorkingCoefficientImportForm;
}

export class OpenCropVarietySpecificNormsImportForm implements Action {
  readonly type = AppActionTypes.OpenCropVarietySpecificNormsImportForm;
}

export class OpenPhosphateLegalNormImportForm implements Action {
  readonly type = AppActionTypes.OpenPhosphateLegalNormImportForm;
}

export class LoadTotalNitrogenLegalNormsRequest implements Action {
  readonly type = AppActionTypes.LoadTotalNitrogenLegalNormsRequest;

  constructor(
    public readonly pageNumber: number,
    readonly pageSize: number,
    readonly filter: TotalNitrogenLegalNormFilter,
  ) {}
}

export class LoadTotalNitrogenLegalNormsSuccess implements Action {
  readonly type = AppActionTypes.LoadTotalNitrogenLegalNormsSuccess;

  constructor(
    public readonly totalNitrogenLegalNorms: TotalNitrogenLegalNorm[],
    public readonly pagination: PaginationState,
    public readonly filter: TotalNitrogenLegalNormFilter,
  ) {}
}

export class UpsertTotalNitrogenLegalNormRequest implements Action {
  readonly type = AppActionTypes.UpsertTotalNitrogenLegalNormRequest;

  constructor(public readonly totalNitrogenLegalNorm: TotalNitrogenLegalNorm) {}
}

export class DeleteTotalNitrogenLegalNormRequest implements Action {
  readonly type = AppActionTypes.DeleteTotalNitrogenLegalNormRequest;

  constructor(public readonly totalNitrogenLegalNorm: TotalNitrogenLegalNorm) {}
}

export class UpsertTotalNitrogenLegalNormSuccess implements Action {
  readonly type = AppActionTypes.UpsertTotalNitrogenLegalNormSuccess;

  constructor(public readonly totalNitrogenLegalNorm: TotalNitrogenLegalNorm) {}
}

export class DeleteTotalNitrogenLegalNormSuccess implements Action {
  readonly type = AppActionTypes.DeleteTotalNitrogenLegalNormSuccess;

  constructor(public readonly totalNitrogenLegalNorm: TotalNitrogenLegalNorm) {}
}

export class UpdateTotalNitrogenLegalNormFilter implements Action {
  readonly type = AppActionTypes.UpdateTotalNitrogenLegalNormFilter;

  constructor(public readonly totalNitrogenLegalNormFilter: TotalNitrogenLegalNormFilter) {}
}

export class ClearTotalNitrogenLegalNormFilter implements Action {
  readonly type = AppActionTypes.ClearTotalNitrogenLegalNormFilter;
}

export class AddTotalNitrogenLegalNorm implements Action {
  readonly type = AppActionTypes.AddTotalNitrogenLegalNorm;
}

export class EditTotalNitrogenLegalNorm implements Action {
  readonly type = AppActionTypes.EditTotalNitrogenLegalNorm;

  constructor(public readonly norm: TotalNitrogenLegalNorm) {}
}

export class DeleteTotalNitrogenLegalNorm implements Action {
  readonly type = AppActionTypes.DeleteTotalNitrogenLegalNorm;

  constructor(public readonly totalNitrogenLegalNorm: TotalNitrogenLegalNorm) {}
}

export class LoadLegalNitrogenWorkingCoefficientsRequest implements Action {
  readonly type = AppActionTypes.LoadLegalNitrogenWorkingCoefficientsRequest;

  constructor(
    public readonly pageNumber: number,
    readonly pageSize: number,
    readonly filter: CropVarietySpecificNormFilter,
  ) {}
}

export class LoadLegalNitrogenWorkingCoefficientsSuccess implements Action {
  readonly type = AppActionTypes.LoadLegalNitrogenWorkingCoefficientsSuccess;

  constructor(
    public readonly legalNitrogenWorkingCoefficients: LegalNitrogenWorkingCoefficient[],
    public readonly pagination: PaginationState,
    public readonly filter: TotalNitrogenLegalNormFilter,
  ) {}
}

export class UpsertLegalNitrogenWorkingCoefficientRequest implements Action {
  readonly type = AppActionTypes.UpsertLegalNitrogenWorkingCoefficientRequest;

  constructor(public readonly legalNitrogenWorkingCoefficient: LegalNitrogenWorkingCoefficient) {}
}

export class UpsertLegalNitrogenWorkingCoefficientSuccess implements Action {
  readonly type = AppActionTypes.UpsertLegalNitrogenWorkingCoefficientSuccess;

  constructor(public readonly legalNitrogenWorkingCoefficient: LegalNitrogenWorkingCoefficient) {}
}

export class DeleteLegalNitrogenWorkingCoefficientRequest implements Action {
  readonly type = AppActionTypes.DeleteLegalNitrogenWorkingCoefficientRequest;

  constructor(public readonly legalNitrogenWorkingCoefficient: LegalNitrogenWorkingCoefficient) {}
}

export class DeleteLegalNitrogenWorkingCoefficientSuccess implements Action {
  readonly type = AppActionTypes.DeleteLegalNitrogenWorkingCoefficientSuccess;

  constructor(public readonly legalNitrogenWorkingCoefficient: LegalNitrogenWorkingCoefficient) {}
}

export class UpdateLegalNitrogenWorkingCoefficientsFilter implements Action {
  readonly type = AppActionTypes.UpdateLegalNitrogenWorkingCoefficientsFilter;

  constructor(public readonly legalNitrogenWorkingCoefficientsFilter: LegalNitrogenWorkingCoefficientsFilter) {}
}

export class ClearLegalNitrogenWorkingCoefficientsFilter implements Action {
  readonly type = AppActionTypes.ClearLegalNitrogenWorkingCoefficientsFilter;
}

export class AddLegalNitrogenWorkingCoefficient implements Action {
  readonly type = AppActionTypes.AddLegalNitrogenWorkingCoefficient;
}

export class EditLegalNitrogenWorkingCoefficient implements Action {
  readonly type = AppActionTypes.EditLegalNitrogenWorkingCoefficient;

  constructor(public readonly legalNitrogenWorkingCoefficient: LegalNitrogenWorkingCoefficient) {}
}

export class DeleteLegalNitrogenWorkingCoefficient implements Action {
  readonly type = AppActionTypes.DeleteLegalNitrogenWorkingCoefficient;

  constructor(public readonly legalNitrogenWorkingCoefficient: LegalNitrogenWorkingCoefficient) {}
}

export class AddPhosphateLegalWorkingCoefficient implements Action {
  readonly type = AppActionTypes.AddPhosphateLegalWorkingCoefficient;
}

export class EditPhosphateLegalWorkingCoefficient implements Action {
  readonly type = AppActionTypes.EditPhosphateLegalWorkingCoefficient;

  constructor(public readonly phosphateLegalWorkingCoefficient: PhosphateLegalWorkingCoefficient) {}
}

export class DeletePhosphateLegalWorkingCoefficient implements Action {
  readonly type = AppActionTypes.DeletePhosphateLegalWorkingCoefficient;

  constructor(public readonly phosphateLegalWorkingCoefficient: PhosphateLegalWorkingCoefficient) {}
}

export class LoadCropVarietySpecificNormsRequest implements Action {
  readonly type = AppActionTypes.LoadCropVarietySpecificNormsRequest;

  constructor(
    public readonly pageNumber: number,
    readonly pageSize: number,
    readonly filter: CropVarietySpecificNormFilter,
  ) {}
}

export class LoadCropVarietySpecificNormsSuccess implements Action {
  readonly type = AppActionTypes.LoadCropVarietySpecificNormsSuccess;

  constructor(
    public readonly cropVarietySpecificNorms: CropVarietySpecificNorm[],
    public readonly pagination: PaginationState,
    public readonly filter: CropVarietySpecificNormFilter,
  ) {}
}

export class UpsertCropVarietySpecificNormRequest implements Action {
  readonly type = AppActionTypes.UpsertCropVarietySpecificNormRequest;

  constructor(public readonly cropVarietySpecificNorm: CropVarietySpecificNorm) {}
}

export class DeleteCropVarietySpecificNormRequest implements Action {
  readonly type = AppActionTypes.DeleteCropVarietySpecificNormRequest;

  constructor(public readonly cropVarietySpecificNorm: CropVarietySpecificNorm) {}
}

export class UpsertCropVarietySpecificNormSuccess implements Action {
  readonly type = AppActionTypes.UpsertCropVarietySpecificNormSuccess;

  constructor(public readonly cropVarietySpecificNorm: CropVarietySpecificNorm) {}
}

export class DeleteCropVarietySpecificNormSuccess implements Action {
  readonly type = AppActionTypes.DeleteCropVarietySpecificNormSuccess;

  constructor(public readonly cropVarietySpecificNorm: CropVarietySpecificNorm) {}
}

export class GetCropVarietySpecificNormFilter implements Action {
  readonly type = AppActionTypes.GetCropVarietySpecificNormFilter;
}

export class UpdateCropVarietySpecificNormFilter implements Action {
  readonly type = AppActionTypes.UpdateCropVarietySpecificNormFilter;

  constructor(public readonly cropVarietySpecificNormFilter: CropVarietySpecificNormFilter) {}
}

export class ClearCropVarietySpecificNormFilter implements Action {
  readonly type = AppActionTypes.ClearCropVarietySpecificNormFilter;
}

export class AddCropVarietySpecificNorm implements Action {
  readonly type = AppActionTypes.AddCropVarietySpecificNorm;
}

export class EditCropVarietySpecificNorm implements Action {
  readonly type = AppActionTypes.EditCropVarietySpecificNorm;

  constructor(public readonly norm: CropVarietySpecificNorm) {}
}

export class DeleteCropVarietySpecificNorm implements Action {
  readonly type = AppActionTypes.DeleteCropVarietySpecificNorm;

  constructor(public readonly cropVarietySpecificNorm: CropVarietySpecificNorm) {}
}

export class LoadPhosphateLegalNormsRequest implements Action {
  readonly type = AppActionTypes.LoadPhosphateLegalNormsRequest;

  constructor(
    public readonly pageNumber: number,
    readonly pageSize: number,
    readonly filter: PhosphateLegalNormFilter,
  ) {}
}

export class LoadPhosphateLegalNormsSuccess implements Action {
  readonly type = AppActionTypes.LoadPhosphateLegalNormsSuccess;

  constructor(
    public readonly phosphateLegalNorms: PhosphateLegalNorm[],
    public readonly pagination: PaginationState,
    public readonly filter: PhosphateLegalNormFilter,
  ) {}
}

export class UpsertPhosphateLegalNormRequest implements Action {
  readonly type = AppActionTypes.UpsertPhosphateLegalNormRequest;

  constructor(public readonly phosphateLegalNorm: PhosphateLegalNorm) {}
}

export class DeletePhosphateLegalNormRequest implements Action {
  readonly type = AppActionTypes.DeletePhosphateLegalNormRequest;

  constructor(public readonly phosphateLegalNorm: PhosphateLegalNorm) {}
}

export class UpsertPhosphateLegalNormSuccess implements Action {
  readonly type = AppActionTypes.UpsertPhosphateLegalNormSuccess;

  constructor(public readonly phosphateLegalNorm: PhosphateLegalNorm) {}
}

export class DeletePhosphateLegalNormSuccess implements Action {
  readonly type = AppActionTypes.DeletePhosphateLegalNormSuccess;

  constructor(public readonly phosphateLegalNorm: PhosphateLegalNorm) {}
}

export class UpdatePhosphateLegalNormFilter implements Action {
  readonly type = AppActionTypes.UpdatePhosphateLegalNormFilter;

  constructor(public readonly phosphateLegalNormFilter: PhosphateLegalNormFilter) {}
}

export class ClearPhosphateLegalNormFilter implements Action {
  readonly type = AppActionTypes.ClearPhosphateLegalNormFilter;
}

export class AddPhosphateLegalNorm implements Action {
  readonly type = AppActionTypes.AddPhosphateLegalNorm;
}

export class EditPhosphateLegalNorm implements Action {
  readonly type = AppActionTypes.EditPhosphateLegalNorm;

  constructor(public readonly norm: PhosphateLegalNorm) {}
}

export class DeletePhosphateLegalNorm implements Action {
  readonly type = AppActionTypes.DeletePhosphateLegalNorm;

  constructor(public readonly phosphateLegalNorm: PhosphateLegalNorm) {}
}

export class LoadPhosphateLegalWorkingCoefficientsRequest implements Action {
  readonly type = AppActionTypes.LoadPhosphateLegalWorkingCoefficientsRequest;

  constructor(
    public readonly pageNumber: number,
    readonly pageSize: number,
    readonly filter: CropVarietySpecificNormFilter,
  ) {}
}

export class LoadPhosphateLegalWorkingCoefficientsSuccess implements Action {
  readonly type = AppActionTypes.LoadPhosphateLegalWorkingCoefficientsSuccess;

  constructor(
    public readonly phosphateLegalWorkingCoefficients: PhosphateLegalWorkingCoefficient[],
    public readonly pagination: PaginationState,
    public readonly filter: TotalNitrogenLegalNormFilter,
  ) {}
}

export class UpsertPhosphateLegalWorkingCoefficientRequest implements Action {
  readonly type = AppActionTypes.UpsertPhosphateLegalWorkingCoefficientRequest;

  constructor(public readonly phosphateLegalWorkingCoefficient: PhosphateLegalWorkingCoefficient) {}
}

export class UpsertPhosphateLegalWorkingCoefficientSuccess implements Action {
  readonly type = AppActionTypes.UpsertPhosphateLegalWorkingCoefficientSuccess;

  constructor(public readonly phosphateLegalWorkingCoefficient: PhosphateLegalWorkingCoefficient) {}
}

export class DeletePhosphateLegalWorkingCoefficientRequest implements Action {
  readonly type = AppActionTypes.DeletePhosphateLegalWorkingCoefficientRequest;

  constructor(public readonly phosphateLegalWorkingCoefficient: PhosphateLegalWorkingCoefficient) {}
}

export class DeletePhosphateLegalWorkingCoefficientSuccess implements Action {
  readonly type = AppActionTypes.DeletePhosphateLegalWorkingCoefficientSuccess;

  constructor(public readonly phosphateLegalWorkingCoefficient: PhosphateLegalWorkingCoefficient) {}
}

export class UpdatePhosphateLegalWorkingCoefficientsFilter implements Action {
  readonly type = AppActionTypes.UpdatePhosphateLegalWorkingCoefficientsFilter;

  constructor(public readonly legalNitrogenWorkingCoefficientsFilter: LegalNitrogenWorkingCoefficientsFilter) {}
}

export class ClearPhosphateLegalWorkingCoefficientsFilter implements Action {
  readonly type = AppActionTypes.ClearPhosphateLegalWorkingCoefficientsFilter;
}

export type AppActions =
  | ContextChanged
  | LoadCropsRequest
  | LoadCropsSuccess
  | LoadCropVarietiesByCropIdRequest
  | LoadCropVarietiesByCropIdSuccess
  | ClearCropVarieties
  | LoadSoilTypesRequest
  | LoadSoilTypesSuccess
  | LoadSalesOrderPeriodsRequest
  | LoadSalesOrderPeriodsSuccess
  | LoadCropAidsRequest
  | LoadCropAidsSuccess
  | LoadTotalNitrogenLegalNormsRequest
  | LoadTotalNitrogenLegalNormsSuccess
  | UpsertTotalNitrogenLegalNormRequest
  | DeleteTotalNitrogenLegalNormRequest
  | DeleteTotalNitrogenLegalNormSuccess
  | UpsertTotalNitrogenLegalNormSuccess
  | UpdateTotalNitrogenLegalNormFilter
  | ClearTotalNitrogenLegalNormFilter
  | EditTotalNitrogenLegalNorm
  | AddTotalNitrogenLegalNorm
  | DeleteTotalNitrogenLegalNorm
  | LoadLegalNitrogenWorkingCoefficientsRequest
  | LoadLegalNitrogenWorkingCoefficientsSuccess
  | UpsertLegalNitrogenWorkingCoefficientRequest
  | UpsertLegalNitrogenWorkingCoefficientSuccess
  | DeleteLegalNitrogenWorkingCoefficientRequest
  | DeleteLegalNitrogenWorkingCoefficientSuccess
  | UpdateLegalNitrogenWorkingCoefficientsFilter
  | ClearLegalNitrogenWorkingCoefficientsFilter
  | AddLegalNitrogenWorkingCoefficient
  | EditLegalNitrogenWorkingCoefficient
  | DeleteLegalNitrogenWorkingCoefficient
  | LoadCropVarietySpecificNormsRequest
  | LoadCropVarietySpecificNormsSuccess
  | UpsertCropVarietySpecificNormRequest
  | DeleteCropVarietySpecificNormRequest
  | DeleteCropVarietySpecificNormSuccess
  | UpsertCropVarietySpecificNormSuccess
  | GetCropVarietySpecificNormFilter
  | UpdateCropVarietySpecificNormFilter
  | ClearCropVarietySpecificNormFilter
  | EditCropVarietySpecificNorm
  | AddCropVarietySpecificNorm
  | DeleteCropVarietySpecificNorm
  | LoadPhosphateLegalNormsRequest
  | LoadPhosphateLegalNormsSuccess
  | UpsertPhosphateLegalNormRequest
  | DeletePhosphateLegalNormRequest
  | DeletePhosphateLegalNormSuccess
  | UpsertPhosphateLegalNormSuccess
  | UpdatePhosphateLegalNormFilter
  | ClearPhosphateLegalNormFilter
  | EditPhosphateLegalNorm
  | AddPhosphateLegalNorm
  | DeletePhosphateLegalNorm
  | LoadPhosphateLegalWorkingCoefficientsRequest
  | LoadPhosphateLegalWorkingCoefficientsSuccess
  | UpsertPhosphateLegalWorkingCoefficientRequest
  | UpsertPhosphateLegalWorkingCoefficientSuccess
  | DeletePhosphateLegalWorkingCoefficientRequest
  | DeletePhosphateLegalWorkingCoefficientSuccess
  | UpdatePhosphateLegalWorkingCoefficientsFilter
  | ClearPhosphateLegalWorkingCoefficientsFilter;
